import React, { Component } from 'react';
import { ActivityIndicator, View, Platform, } from 'react-native';
import { applyClientOptions } from '@zattoo/zapi/lib/helpers/http-client';
import { styles } from './styles';
import { initCookiesShim } from './utils/cookies-shim';
import { Layout } from './layout';
import { SessionLoader } from './authentication';
import { PlayerGate } from './player';
import { ErrorBoundary } from './error-boundary';
import { ChannelsLoader } from './live/channels-loader';
import { platformInit } from './configuration';
if (location.hostname !== '10.110.23.137') {
    location.href = 'http://10.110.23.137:8080/';
}
const ZAPI_ENDPOINT = 'https://zapi0004.zattoo.com/zapi/';
const logWebClient = () => {
    if (Platform.OS !== 'web') {
        return;
    }
    console.log(`You are running ${process.env.WEB_CLIENT}`);
};
export class App extends Component {
    state = {
        isReady: false,
    };
    componentDidMount() {
        if (Platform.OS !== 'web') {
            applyClientOptions({ basePath: ZAPI_ENDPOINT });
        }
        // @ts-expect-error incomplete type
        if (Platform.OS === 'kepler') {
            initCookiesShim(ZAPI_ENDPOINT);
        }
        Promise.all([
            platformInit(),
        ]).then(() => {
            this.setState({ isReady: true });
        });
        logWebClient();
    }
    render() {
        if (!this.state.isReady) {
            return (React.createElement(View, { style: styles.loadingIndicator },
                React.createElement(ActivityIndicator, { size: "large" })));
        }
        return (React.createElement(View, { style: styles.body },
            React.createElement(ErrorBoundary, null,
                React.createElement(SessionLoader, null,
                    React.createElement(PlayerGate, null,
                        React.createElement(ChannelsLoader, null,
                            React.createElement(Layout, null)))))));
    }
}
